
    import './styles.scoped.css';
    export default {
  "error-icon-shake-wrapper": "awsui_error-icon-shake-wrapper_14mhv_1depx_149",
  "warning-icon-shake-wrapper": "awsui_warning-icon-shake-wrapper_14mhv_1depx_150",
  "awsui-motion-shake-horizontally": "awsui_awsui-motion-shake-horizontally_14mhv_1depx_1",
  "error-icon-scale-wrapper": "awsui_error-icon-scale-wrapper_14mhv_1depx_180",
  "warning-icon-scale-wrapper": "awsui_warning-icon-scale-wrapper_14mhv_1depx_181",
  "awsui-motion-scale-popup": "awsui_awsui-motion-scale-popup_14mhv_1depx_1",
  "warning": "awsui_warning_14mhv_1depx_150",
  "error": "awsui_error_14mhv_1depx_149",
  "awsui-motion-fade-in-0": "awsui_awsui-motion-fade-in-0_14mhv_1depx_1",
  "root": "awsui_root_14mhv_1depx_232",
  "label": "awsui_label_14mhv_1depx_265",
  "info": "awsui_info_14mhv_1depx_281",
  "description": "awsui_description_14mhv_1depx_287",
  "constraint": "awsui_constraint_14mhv_1depx_288",
  "hints": "awsui_hints_14mhv_1depx_295",
  "constraint-has-validation-text": "awsui_constraint-has-validation-text_14mhv_1depx_296",
  "secondary-control": "awsui_secondary-control_14mhv_1depx_300",
  "controls": "awsui_controls_14mhv_1depx_304",
  "label-hidden": "awsui_label-hidden_14mhv_1depx_304",
  "label-wrapper": "awsui_label-wrapper_14mhv_1depx_307",
  "control": "awsui_control_14mhv_1depx_304",
  "error__message": "awsui_error__message_14mhv_1depx_334",
  "warning__message": "awsui_warning__message_14mhv_1depx_335",
  "visually-hidden": "awsui_visually-hidden_14mhv_1depx_339"
};
  